import { ActivationRequiredErrorType } from './types'

export default class ActivationRequiredError extends Error {
  public reason: ActivationRequiredErrorType
  constructor(reason: ActivationRequiredErrorType) {
    super(`Activation required: ${reason}`)
    this.name = 'ActivationRequiredError'
    this.reason = reason
  }
}
